export default [
  {
    id: 4,
    label: 'urgent',
    icon: 'chevrons-up',
    customIcon: true,
    customIconColor: '#F04438',
  },
  {
    id: 3,
    label: 'high',
    icon: 'chevron-up',
    customIcon: true,
    customIconColor: '#F79009',
  },
  {
    id: 2,
    label: 'medium',
    icon: 'chevron-down',
    customIcon: true,
    customIconColor: '#12B76A',
  },
  {
    id: 1,
    label: 'low',
    icon: 'chevrons-down',
    customIcon: true,
    customIconColor: '#4A9AFF',
  },
  {
    id: 0,
    label: 'noPriority',
    icon: 'minus',
    customIcon: true,
  },
];
